import { ref, onMounted, onBeforeUnmount } from 'vue'
import PcSlideBanner from './PcSlideBanner.vue';

export default {
  __name: 'SlideBanner',
  setup(__props) {

const onboarding = ref(1)

const dados = ref([
  {
    title: "Renove seu Certificado Digital",
    description:
      "Renovar o Certificado Digital é simples e pode ser feito 100% online garantindo praticidade e segurança na conclusão de suas transações.",
    img: "/images/img-slide-banner/img-banner-renovacao-mb.png",
    link: "https://wa.me/554192848223?text=Ol%C3%A1%2C%20gostaria%20de%20renovar%20meu%20certificado%20digital.",
  },
  {
    title: "Renove seu Certificado Digital SIPASS",
    description:
      "Você que já adquiriu o seu Certificado Digital no ano anterior. Aproveite as condições especiais para renovação.",
    img: "/images/img-slide-banner/img-banner-sispass-mb.png",
    link: "https://wa.me/554192848223?text=Ol%C3%A1%2C%20gostaria%20de%20renovar%20meu%20certificado%20digital.",
  },
  {
    title: "Certificado Digital para Produtor Rural",
    description:
      "A partir de 3 de fevereiro de 2025, produtores rurais com receita bruta anual acima de R$ 360 mil serão obrigados a emitir Nota Fiscal Eletrônica. Com o Certificado Digital A1, esse processo será mais seguro e ágil.",
    img: "/images/img-slide-banner/img-banner-produtor-mb.png",
    link: "../pages/e-cnpj"
  },
]);

let intervalId = null;

onMounted(() => {
  intervalId = setInterval(() => {
    onboarding.value = onboarding.value >= dados.value.length ? 1 : onboarding.value + 1
  }, 20000)
});

onBeforeUnmount(() => {
  clearInterval(intervalId)
});

function next() {
  onboarding.value = onboarding.value + 1 > dados.value.length ? 1 : onboarding.value + 1
}

function prev() {
  onboarding.value = onboarding.value - 1 <= 0 ? dados.value.length : onboarding.value - 1
}

function openLink(link) {
  console.log('Opening link:', link);
  if (link) {
    window.open(link, '_blank')
  }
}



return { __sfc: true,onboarding, dados, intervalId, next, prev, openLink, PcSlideBanner }
}

}